import localforage from 'localforage'
import { REGION } from '@ms/config/app'

localforage.config({
  name: REGION
})

localforage.dropInstance({
  name: 'common'
})

export default localforage
